/* eslint-disable vue/require-component-is */
<template>
  <div class="exchangeBaseInfo">
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        换货合同
      </div>
      <div class="rj-page-card__content">
        <el-form ref="form" :model="info" :rules="rules" class="baseInfoForm">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ infoAll.rprojectName }}
              </div>
            </div>
          </div>
          <div class="rj-row">
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  原合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.roldContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rcreatedTime }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  电子商务合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rnewContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  客户合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  <el-input v-model="infoAll.rnewContractCustomerNum" disabled placeholder="请输入客户合同编号" />
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单分类：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rorderType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.supplyUnit }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位地址：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.supplyAddress }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位电话(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.supplyPhone }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位(乙方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rorderUnitName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位电话(乙方)：
                </div>
                <div class="rj-baseinfo__item">
                  <el-input v-model="infoAll.rorderUnitTel" placeholder="请输入订货单位电话" />
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  最终客户：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rfinalCustomerName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  客户签约类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.customerContractType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rsalesArea }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  首级集成商名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rintegratorName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  首级集成商类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rintegratorSignType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域商务专员：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rassistantName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  售前名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rpreSalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  销售名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rsalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  部门：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rsalesPersonDeptName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  计量计点：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rmeteringPoint }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  服务主体编码：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rserviceSubjectCode }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  服务主体名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rserviceSubjectName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  A类产品服务商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rserviceAName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  B类产品服务商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rserviceBName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  C类产品服务商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rserviceCName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  现销或赊销：
                </div>
                <div class="rj-baseinfo__item">
                  <div class="rj-baseinfo__item">
                    <el-radio v-model="infoAll.rsalesSettlementModes" :label="1" disabled>
                      现销
                    </el-radio>
                    <el-radio v-model="infoAll.rsalesSettlementModes" :label="2" disabled>
                      赊销
                    </el-radio>
                  </div>
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  账期：
                </div>
                <div class="rj-baseinfo__item">
                  <div class="rj-baseinfo__item force-line-break">
                    {{ infoAll.raccountPeriod }}
                  </div>
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  发货方式：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rdeliveryMethod!==2?"齐套发货":"分批发货" }}
                </div>
              </div>
            </div>

            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  是否使用返利：
                </div>
                <div class="rj-baseinfo__item">
                  <div class="rj-baseinfo__item">
                    <el-radio-group v-model="infoAll.risUseRebate" :disabled="risUseRebateDisabled" @change="changisRebate">
                      <el-radio :label="1">
                        是
                      </el-radio>
                      <el-radio :label="0">
                        否
                      </el-radio>
                    </el-radio-group>
                  </div>
                  <template v-if="infoAll.risUseRebate === 1">
                    使用金额: {{ infoAll.ruseRebateAmount || 0 }} 元
                    <component
                      :is="componentType"
                      v-bind="dialogNode"
                      @chooesSuccess="chooseRebateSuccess"
                    />
                  </template>
                </div>
              </div>
            </div>

            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  齐套通知打款邮箱：
                </div>
                <div class="rj-baseinfo__item">
                  <el-input v-model="infoAll.businessEmail" placeholder="请输入齐套通知打款邮箱" />
                </div>
              </div>
            </div>
            <!-- <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">收款银行：</div>
                <div class="rj-baseinfo__item">
                  <div class="rj-baseinfo__item">{{ infoAll.openBankName }}</div>
                </div>
              </div>
            </div> -->
            <payment-bank ref="bank" v-model="infoAll" :contract-num="this.$route.query.rnewContractNum" />
            <div class="rj-col-1">
              <el-form-item prop="additionalTerms" label="补充条款:">
                <el-input v-model.trim="infoAll.rsupplementalTerm" type="textarea" :rows="3" placeholder="请输入补充条款内容" />
              </el-form-item>
            </div>
            <div class="rj-col-1">
              <el-form-item prop="additionalTerms" label="备注说明:">
                <el-input v-model.trim="infoAll.rremarks" type="textarea" :rows="3" placeholder="请输入备注说明" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getEditRebateUsedList,
  getChangeGoodsAllowUseRebate
} from '@/API';
import rebateUse from '../../../Chief/contract/rabateUseRturnExchange.vue';
import rebateUsedList from '../../../Chief/contract/rebateUsedListRturnExchange.vue';
const paymentBank = () => import('./paymentBank');

/* eslint-disable */
export default {
  components: {
    rebateUse,
    rebateUsedList,
    paymentBank
  },

  props: {
    info: {
      type: Object,
      default: () => { return {}; }
    }
  },

  data () {
    return {
      infoAll: this.info,
      loading: false,
      form: {},
      rules: {},
      componentType: '',
      risUseRebateDisabled: false,
      dialogNode: {
        allow: 0, //当前合同最大返利金额
        availableRebateAmount: 0,
        rebateUsedList: [],
        customerContractType: this.info.customerContractType
      }
    };
  },

  watch:{
    info:{
      handler(val){
        this.infoAll = val;
        this.dialogNode.allow = this.infoAll.rorderMoney;
      },
      deep: true
    },

    'infoAll.rprojectName'(){
      this.getEditRebateUsedList();
    },

    // 返利使用金额
    'infoAll.ruseRebateAmount'(newVal){
      this.$emit('changeRebateCount', newVal)
    },

    'infoAll.customerContractType' (newVal) {
     this.dialogNode.customerContractType = newVal;
    },

  },

  methods: {
    changisRebate (val) {
      if (val === 0) {
        this.infoAll.ruseRebateAmount = 0;
        this.dialogNode.rebateUsedList = [];
      }
    },

    chooseRebateSuccess (val) {
      // 赋值过程toFixed();
      this.infoAll.ruseRebateAmount = Number(val.total);
      this.dialogNode.rebateUsedList = val.list;
      this.info.rebateItemVOList = val.list.map(row => {
        return {
          rebateNum: row.rebateNumber,
          rebateAmount: row.useAmount,
          rebateTypeName: row.strRebateType
        }
      })
    },

    // 返利 接口
    getEditRebateUsedList () {
      getEditRebateUsedList({ contractNum: this.$route.query.rnewContractNum }).then((res) => {
          let {status,data } = res.data;
          if (status === '200') {
            if (data.length) {
              this.info.rebateItemVOList = data.map(row => {
                return {
                  rebateNum: row.rebateNumber,
                  rebateAmount: row.useAmount,
                  rebateTypeName: row.strRebateType
                }
              })
              this.dialogNode.rebateUsedList = data;
              this.componentType = 'rebate-used-list'
            } else {
               this.componentType = 'rebate-use'
            }
          }
      })

      getChangeGoodsAllowUseRebate({ contractNum: this.$route.query.roldContractNum }).then((res) => {
          let { status, data } = res.data;
          if (status === '200') {
            this.dialogNode.availableRebateAmount = data.availableAmount;
            // 如果原单使用了返利 && 可用返利金额 大于0，可以自由选择。
            if (Number(data.availableAmount || 0) > 0 && (data.originalContractUseRebate || this.infoAll.rcontractType === '价外费用合同')) {
              this.infoAll.risUseRebate = 0
            } else {
              this.risUseRebateDisabled = true
            }
          }
      })
    }
  }
};
</script>

<style lang='scss'>
.exchangeBaseInfo{
 .rj-col-66 {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 66.6666%;
}
}

</style>
